import DetailSeleksiVendor from './DetailSeleksiVendor'

export default DetailSeleksiVendor